// eslint-disable-next-line no-unused-vars
import React from "react"
import { Marker, Popup } from 'react-leaflet'
import L from 'leaflet'
import DOMPurify from 'dompurify'
import { useConfig } from "../../context/ConfigContext"
import { useTranslation } from "../../hooks/useTranslation"

const POIMarker = React.memo(function POIMarker({ poi, lat, lng, trackid, onClick }) {
    const { shared } = useConfig();
    const { t } = useTranslation();

    const myIcon = L.icon({
        iconUrl: (poi.icon_type === "HREF" ? poi.icon : "undefined"),
        iconSize: [56, 56],
        iconAnchor: [28, 28],
        popupAnchor: [0, -28],
        shadowUrl: null,
        shadowSize: null,
        shadowAnchor: null,
    });

    // Check if this is the home POI (based on matching coordinates or name)
    const homePoi = shared?.tracker?.homePoi;
    const isHomePoi = homePoi?.enabled && (
        poi.title?.toLowerCase().includes('ijssalon') ||
        poi.title?.toLowerCase().includes('foubert') ||
        (Math.abs(poi.latitude - (homePoi.latitude || 0)) < 0.001 &&
         Math.abs(poi.longitude - (homePoi.longitude || 0)) < 0.001)
    );

    const showRestaurantButton = shared?.tracker?.showRestaurantButton;
    const restaurantUrl = shared?.links?.restaurantReservation;

    const handleRouteClick = (e) => {
        e.stopPropagation();
        const address = encodeURIComponent(homePoi?.address || `${poi.latitude},${poi.longitude}`);
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

        if (isIOS) {
            window.open(`maps://maps.apple.com/?daddr=${address}&dirflg=d`, '_blank');
        } else {
            window.open(`https://www.google.com/maps/dir/?api=1&destination=${address}`, '_blank');
        }
    };

    const handleRestaurantClick = (e) => {
        e.stopPropagation();
        if (restaurantUrl) {
            window.open(restaurantUrl, '_blank');
        }
    };

    return (
        <Marker
            icon={myIcon}
            key={"poimarker" + poi.id}
            eventHandlers={{
                click: () => { onClick(trackid, poi.latitude, poi.longitude); }
            }}
            position={[lat, lng]}
        >
            <Popup className="poi-popup">
                <div className="poi-popup-content">
                    <h6>{poi.title}</h6>
                    <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(poi.subtitle || '', { ALLOWED_TAGS: ['b', 'strong', 'i', 'em', 'br'] }) }}></p>
                    {isHomePoi && (
                        <div className="poi-popup-actions">
                            <button
                                type="button"
                                className="poi-action-btn route-btn"
                                onClick={handleRouteClick}
                            >
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                                    <circle cx="12" cy="10" r="3"/>
                                </svg>
                                {t('tracker.poiPopup.routeButton', 'Route')}
                            </button>
                            {showRestaurantButton && restaurantUrl && (
                                <button
                                    type="button"
                                    className="poi-action-btn restaurant-btn"
                                    onClick={handleRestaurantClick}
                                >
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/>
                                        <path d="M7 2v20"/>
                                        <path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"/>
                                    </svg>
                                    {t('tracker.poiPopup.reserveButton', 'Reserveer')}
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </Popup>
        </Marker>
    );
});

// Custom comparison to prevent unnecessary re-renders during polling
POIMarker.displayName = 'POIMarker';

export default POIMarker